import LineOrange from "../../../common/LineOrange/LineOrange";

export const ApplicationOfTheCertificate2 = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "#F2F4F6" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
            <h3 className="text-right mt-5">مزایای مرتبط با ناشر متقاضی</h3>
            <LineOrange />
          </div>
          <div
            className="d-flex  align-items-center justify-content-center mb-5"
            style={{ minHeight: "50vh" }}
          >
            <div className="row align-items-center w-100 ">
              <div className="col-12 col-lg-7">
                <ul className="text-right mt-3">
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    سهولت‌ تامین‌ مالی‌ شرکت‌ها از طریق‌ بورس
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    افزایش‌ نقدشوندگی‌ سهام و کاهش‌ هزینه‌ سرمایه‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    برخورداري از معافیت‌ مالیاتی‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    امکان استفاده از مشارکت‌ عمومی‌ در توسعه‌ شرکت‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    تعیین‌ قیمت‌ سهام و اوراق بهادار شرکت‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    استفاده از معیاري مناسب‌ براي مقایسه‌ شرکت‌ بـا سـایر
                    شـرکت‌ها{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    سهولت‌ در تغییر ترکیب‌ سهامداران و انتقال پذیري مالکیت‌
                    صنعت‌ ‌ ثروت{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    افزایش‌ اعتبار داخلی‌ و بین‌المللی‌ به واسطه پذیرش در بورس‌
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    بهبود ساختار مالی‌ و اقتصادي شرکت‌ در نتیجه‌ رعایت‌ الزامات
                    پذیرش شرکت‌ اوراق بهادار{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    تسهیل‌ وثیقه‌گذاري سهام توسط‌ سهامداران{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    ایجاد انگیزه در کارکنان از طریق‌ طرحهاي واگذاري اوراق بهادار{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    سهولت‌ تأمین‌ مـالی‌ از سیستم بـانکی‌{" "}
                  </li>
                </ul>
              </div>
              {/* <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/02.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
